import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Dropdown,
    Dimmer,
    Loader
} from "semantic-ui-react";
import HotspotAutomation from "../../ControlPanelComponents/Corporate Automation/HotspotAutomation.jsx";
import SmartspotAutomation from "../../ControlPanelComponents/Corporate Automation/SmartspotAutomation.jsx"
import Wholesale from "../Corporate Automation/Wholesale.jsx";
// import Titan from "../Corporate Automation/Titan.jsx";
import OlayBC from "../Corporate Automation/OlayBC.jsx";
import GilletteBin from "../Corporate Automation/GilletteBin.jsx";
import WholesaleQPS from "../Corporate Automation/WholesaleQPS.jsx";
import Olay from "../Corporate Automation/Olay.jsx";
import { fetchTemplates, fetchUseraction } from '../../../actions/users_action';

class Automation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDisbursement: '',
            // shared template + distributor state (used by Smartspot)
            templates: [],
            templateId: '',
            selectedTemplate: '',
            distributors: [],
            selectedDistributor: [],
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                const last = res.templates[res.templates.length - 1];
                this.setState({
                    templates: res.templates,
                    selectedTemplate: last.name,
                    templateId: last._id,
                }, () => this._loadDistributors(last._id));
            },
            onFailure: () => {}
        });
    }

    _loadDistributors = (templateId) => {
        this.props.fetchUseraction(templateId, {
            onSuccess: (res) => {
                const dis_list = [];
                if (res.users.length > 0) {
                    res.users.forEach((u) => {
                        if (u.siteName && u.role === 'distributor') {
                            dis_list.push({ key: u.siteName, value: u.siteName, text: u.siteName });
                        }
                    });
                }
                dis_list.push({ key: 'All', value: 'All', text: 'All' });
                this.setState({ distributors: dis_list, selectedDistributor: [] });
            },
            onFailure: () => {}
        });
    }

    dropDownDisbursementOnChange = (e, data) => {
        this.setState({ selectedDisbursement: data.value });
    }

    dropDownTemplateOnChange = (e, data) => {
        const chosen = this.state.templates.find(t => t.name === data.value);
        if (!chosen) return;
        this.setState({
            selectedTemplate: data.value,
            templateId: chosen._id,
            selectedDistributor: [],
        }, () => this._loadDistributors(chosen._id));
    }

    dropDownDistributorOnChange = (e, data) => {
        let filtered;
        if (data.value.includes('All') && data.value.length > 0) {
            filtered = data.value.filter(v => v === 'All');
        } else {
            filtered = data.value.filter(v => v !== 'All');
        }
        this.setState({ selectedDistributor: filtered });
    }

    render() {

        const templateMonths = this.state.templates.map(d => ({
            key: d._id,
            value: d.name,
            text: d.name,
        }));

        var disbursment_list = [
            { key: 'Hotspot',      value: 'Hotspot',      text: 'Hotspot' },
            { key: 'Smartspot',    value: 'Smartspot',    text: 'Smartspot' },
            { key: 'Wholesale',    value: 'Wholesale',    text: 'Wholesale' },
            { key: 'Wholesale QPS',value: 'Wholesale QPS',text: 'Wholesale QPS' },
            { key: 'Olay BC',      value: 'Olay BC',      text: 'Olay BC' },
            { key: 'Olay',          value: 'Olay',          text: 'Olay' }
        ]

        const isSmartspot = this.state.selectedDisbursement === 'Smartspot';

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                    <p style={{ fontSize: 25, margin: 0 }}>
                        <h1 style={{ flex: "0 0 30px", display: "inline-block", color: "#2185d0" }}>
                            Disbursement Automation Process
                        </h1>
                    </p>
                    <div style={{ marginLeft: 20 }}>
                        <Dropdown
                            placeholder='Select Disbursement'
                            search selection
                            options={disbursment_list}
                            onChange={this.dropDownDisbursementOnChange}
                            value={this.state.selectedDisbursement}
                        />
                    </div>

                    {/* Template + Distributor shown when Smartspot is selected */}
                    {isSmartspot && (
                        <>
                            <div style={{ marginLeft: 10 }}>
                                <Dropdown
                                    placeholder='Select Template Month'
                                    search selection
                                    options={templateMonths}
                                    onChange={this.dropDownTemplateOnChange}
                                    value={this.state.selectedTemplate}
                                />
                            </div>
                            <div style={{ marginLeft: 10 }}>
                                <Dropdown
                                    placeholder='Select Distributor'
                                    search selection multiple
                                    options={this.state.distributors}
                                    onChange={this.dropDownDistributorOnChange}
                                    value={this.state.selectedDistributor}
                                />
                            </div>
                        </>
                    )}
                </div>

                {this.state.selectedDisbursement === 'Hotspot' && 
                <HotspotAutomation />
                }
                {isSmartspot && 
                <SmartspotAutomation
                    templateId={this.state.templateId}
                    selectedTemplate={this.state.selectedTemplate}
                    distributors={this.state.distributors}
                    selectedDistributor={this.state.selectedDistributor}
                />
                }
                {this.state.selectedDisbursement === 'Wholesale' && 
                <Wholesale />
                }
                {this.state.selectedDisbursement === 'Wholesale QPS' && 
                <WholesaleQPS />
                }
                {this.state.selectedDisbursement === 'Olay BC' && 
                <OlayBC />
                }
                {this.state.selectedDisbursement === 'Gillette BIN' && 
                <GilletteBin />
                }
                {this.state.selectedDisbursement === 'Olay' && 
                <Olay />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchTemplates,
            fetchUseraction,
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Automation));
